import styled from 'styled-components';

const ResultsInner = styled.div`
  padding: 30px 0;
`;

ResultsInner.displayName = 'ResultsInner';

export default ResultsInner;
